import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {  jumpToWallet } from 'src/helper/webviewFun'

import {
  setDocumentTitle,
  setUidToken,
  showConsole,
  getlang,
  setlang,
  score,
  unix2date6,
  forbidScroll,
  debounce,
  throttle,
  inject,
  observer,
  openViewTransparent
} from '../../../helper/devTools.js'

import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';
import localstorage from 'src/helper/localstorage'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    // this.welfareStore = this.props.store.register('activity/welfare')
    setDocumentTitle('APP GAME')
  }
  state = {
    messageTxt: "",
    lang:langM.en,
    language:'en',
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
    openViewTransparent(true)

    window.addEventListener('message', function (e) {
      if (e.data && e.data!="") {
        try {
          let d = JSON.parse(e.data)
          if (d.msgtp == "popRecharge") {
            console.log("触发顶层逻辑",d.content)
            jumpToWallet(1)
          }
        } catch (error) {
          // console.error(error)
        } 

      }
    }, false)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
 
  }

  
  post1 = async (msg) => {
    // 第一步,要拿到iframe,这里主要是拿到iframe.contentWindow
    let iframe = document.getElementById('frameName1')
    let iframeWindow = iframe.contentWindow // 利用iframe.contentWindow 也就是4.html 的window对象.
    let map = {"msgtp":"refresh","content":"这里是发送的内容1"}
    // iframeWindow.postMessage(JSON.stringify(map),'http://localhost:8000') // 第二个参数,指定4.html的域名
    iframeWindow.postMessage(JSON.stringify(map),'http://47.243.131.25') // 第二个参数,指定4.html的域名
    
  }

  render() {
    const { accesstoken, uid } = localstorage.get('userInfo')
    return (
      <div className={`app-games-wrapper`}>
        <div onClick={this.post1.bind(this, "msg1")}>从顶层往iframe传送</div>
        <iframe
          className="app-games-iframe"
          id='frameName1'
          src={`http://47.243.131.25/game/?uid=${uid}&token=${accesstoken}&avatar=http://img.chatie.live/app/man.jpg`}
          // src={`http://localhost:8000/#/app/iframe2`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
        </iframe>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/test/iframe1/index.js